import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { environment as env } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
interface HttpOptions {
  headers?: HttpHeaders;
  params?: HttpParams;
  skipLoader?: boolean;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService
  ) {}

  private buildOptions(options: HttpOptions = {}): any {
    let headers = options.headers ?? new HttpHeaders();

    if (options.skipLoader) {
      headers = headers.set('X-Skip-Loader', 'true');
    }

    headers = headers.set(
      'language-locale',
      this.storageService.getFromLocalOrSessionStorage('language-locale') ?? env.defaultLanguage
    );

    const { skipLoader, ...rest } = options;

    return {
      ...rest,
      headers
    };
  }

  get<T>(url: string, options?: HttpOptions): Observable<any> {
    return this.http.get<T>(url, this.buildOptions(options));
  }

  post<T>(url: string, body: any, options?: HttpOptions): Observable<any> {
    return this.http.post<T>(url, body, this.buildOptions(options));
  }

  put<T>(url: string, body: any, options?: HttpOptions): Observable<any> {
    return this.http.put<T>(url, body, this.buildOptions(options));
  }

  delete<T>(url: string, options?: HttpOptions): Observable<any> {
    return this.http.delete<T>(url, this.buildOptions(options));
  }

  patch<T>(url: string, body: any, options?: HttpOptions): Observable<any> {
    return this.http.patch<T>(url, body, this.buildOptions(options));
  }
}
